import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { EFormService } from '../../../../../shared-components/e-forms/e-form.service';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs';
import { TylerMatTableDataSource } from '../../../../../shared-components/angular-material/extended.class';
import { detailExpand } from '../../../../../shared-components/angular-material/mat-animations';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { EFormTab } from '../../../../../shared-components/e-forms/e-form-tab.model';
import { EFormPage } from '../../../../../shared-components/e-forms/e-form-page.model';
import { EFormDataObject } from '../../../../../shared-components/e-forms/e-formDataObject.model';
import { EFormRow } from '../../../../../shared-components/e-forms/e-form-row.model';
import { EFormColumn } from '../../../../../shared-components/e-forms/e-form-column.model';
import { EFormControl } from '../../../../../shared-components/e-forms/e-form-control.model';
import { MatDialog } from '@angular/material/dialog';
import { GeneralConfirmationComponent } from '../../../../../shared-components/controls/general-confirmation/general-confirmation.component';
import { EFormDesignerService } from '../../e-form-designer.service';
import { EFormRrowColumnLocationComponent } from '../../e-form-row-column-location/e-form-row-column-location';
import { LoginService } from '../../../../../shared-modules/login/login.service';
import { EFormConfiguration } from '../../../e-form-config.model';

@AutoUnsubscribe({ includeArrays: true })
@Component({
  selector: 'e-form-navigation-panel',
  templateUrl: './e-form-navigation-panel.component.html',
  styleUrls: ['./e-form-navigation-panel.component.css'],
  animations: [
    detailExpand
  ]
})
export class EFormNavigationPanelComponent implements OnInit, OnDestroy {

  @Input() config = new EFormConfiguration();
  dataSource: TylerMatTableDataSource = new TylerMatTableDataSource();
  columnsToDisplay = ['More', 'Tab'];
  eForm: EFormDataObject;
  subscriptions: Subscription[] = [];
  selectedTab: EFormTab;
  selectedPage: EFormPage;
  selectedColumn: EFormColumn;
  selectedRow: EFormRow;
  selectedControl: EFormControl;
  selectedElementType: string;
  isDevMode: boolean;

  constructor(
    private eformService: EFormService,
    private eFormDesignerService: EFormDesignerService,
    private dialog: MatDialog,
    private loginService: LoginService
  ) {

  }

  ngOnInit() {
    this.eForm = this.eformService.selectedFormData;
    this.selectedTab = this.eFormDesignerService.selectedTab;
    this.selectedPage = this.eFormDesignerService.selectedPage;
    this.selectedColumn = this.eFormDesignerService.selectedColumn;
    this.selectedRow = this.eFormDesignerService.selectedRow;
    this.selectedControl = this.eFormDesignerService.selectedControl;
    this.selectedElementType = this.eFormDesignerService.selectedElementType;
    this.isDevMode = this.loginService.LoginSettings.CustomizationDevMode;
    this.subscriptions.push(this.eFormDesignerService.observableselectedElementChangedStream$.subscribe(o => {
      this.selectedControl = this.eFormDesignerService.selectedControl;
      this.selectedRow = this.eFormDesignerService.selectedRow;
      this.selectedColumn = this.eFormDesignerService.selectedColumn;
      this.selectedPage = this.eFormDesignerService.selectedPage;
      this.selectedTab = this.eFormDesignerService.selectedTab;
      this.selectedElementType = this.eFormDesignerService.selectedElementType;
    }));
  }

  dropTab(event: CdkDragDrop<EFormTab[]>) {
    moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    this.eFormDesignerService.observableTabNameChanged.next(true);
  }

  dropPage(event: CdkDragDrop<EFormPage[]>) {
    moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
  }

  ngOnDestroy() { }

  toggleNode(node: any) {
    node.Expanded = !node.Expanded;
    event.stopPropagation();
  }

  tabClick(tab: EFormTab) {
    this.eFormDesignerService.focusOnTab(tab);
  }

  pageClick(page: EFormPage) {
    this.eFormDesignerService.focusOnPage(page);
    event.stopPropagation();
  }

  columnClick(col: EFormColumn) {
    this.eFormDesignerService.focusOnColumn(col);
    event.stopPropagation();
  }

  rowClick(row: EFormRow) {
    this.eFormDesignerService.focusOnRow(row);
    event.stopPropagation();
  }

  controlClick(control: EFormControl) {
    this.eFormDesignerService.focusOnControl(control);
    event.stopPropagation();
  }

  editClick() {
    this.eFormDesignerService.openPropertiesTab();
  }

  deleteClick(type: string) {
    setTimeout(() => {
      if (type.toLowerCase() == 'tab' && this.eformService.selectedFormData.Tabs.length == 1) {
        const deleteConfirmDialog = this.dialog.open(GeneralConfirmationComponent, {
          disableClose: true,
        });
        deleteConfirmDialog.componentInstance.informational = true;
        deleteConfirmDialog.componentInstance.headerLabel = 'WARNING';
        deleteConfirmDialog.componentInstance.confirmMessage = 'Cannot delete last tab. Create a new tab first.';
      }
      else {
        // check for controls that cannot be removed from form
        let hasNonRemovableControls = false;
        let canDelete = true;
        if (type == 'Control') {
          hasNonRemovableControls = this.eFormDesignerService.selectedControl.CannotBeRemoved;
        }
        else if (type == 'Row') {
          hasNonRemovableControls = this.eFormDesignerService.rowHasNonRemovableControls(this.eFormDesignerService.selectedRow);
        }
        else if (type == 'Column') {
          if (!this.eFormDesignerService.canDeleteColumn(this.eFormDesignerService.selectedColumn)) {
            canDelete = false;
            const deleteConfirmDialog = this.dialog.open(GeneralConfirmationComponent, {
              disableClose: true,
            });
            deleteConfirmDialog.componentInstance.informational = true;
            deleteConfirmDialog.componentInstance.headerLabel = 'WARNING';
            deleteConfirmDialog.componentInstance.confirmMessage = 'You cannot remove the last column on a page.';
          }
          else {
            hasNonRemovableControls = this.eFormDesignerService.columnHasNonRemovableControls(this.eFormDesignerService.selectedColumn);
          }
        }
        else if (type == 'Page') {
          if (!this.eFormDesignerService.canDeletePage(this.eFormDesignerService.selectedPage)) {
            canDelete = false;
            const deleteConfirmDialog = this.dialog.open(GeneralConfirmationComponent, {
              disableClose: true,
            });
            deleteConfirmDialog.componentInstance.informational = true;
            deleteConfirmDialog.componentInstance.headerLabel = 'WARNING';
            deleteConfirmDialog.componentInstance.confirmMessage = 'You cannot remove the last page in a tab.';
          }
          else {
            hasNonRemovableControls = this.eFormDesignerService.pageHasNonRemovableControls(this.eFormDesignerService.selectedPage);
          }
        }
        else if (type == 'Tab') {
          hasNonRemovableControls = this.eFormDesignerService.tabHasNonRemovableControls(this.eFormDesignerService.selectedTab);
        }

        if (hasNonRemovableControls && (!this.isDevMode || !this.config.BasePage)) {
          const headerLabel = 'Delete ' + type;
          let message = '';
          if (type == 'Control') {
            message = 'This control cannot be removed.';
          }
          else {
            message = 'This ' + type + ' contains controls that cannot be removed.';
          }

          const deleteConfirmDialog = this.dialog.open(GeneralConfirmationComponent, {
            disableClose: true,
          });
          deleteConfirmDialog.componentInstance.headerLabel = headerLabel;
          deleteConfirmDialog.componentInstance.confirmMessage = message;
          deleteConfirmDialog.componentInstance.informational = true;
        }
        else if (canDelete) {
          const headerLabel = 'Delete ' + type;
          let message = '';
          if (type == 'Control') {
            message = 'Are you sure you want to delete this control?';
          }
          else {
            message = 'Are you sure you want to delete this ' + type + ' and all its content?';
          }

          const deleteConfirmDialog = this.dialog.open(GeneralConfirmationComponent, {
            disableClose: true,
          });
          deleteConfirmDialog.componentInstance.headerLabel = headerLabel;
          deleteConfirmDialog.componentInstance.confirmMessage = message;
          deleteConfirmDialog.componentInstance.confirmEvent.subscribe((deleteObject: boolean) => {
            if (deleteObject) {
              this.eFormDesignerService.deleteSelectedElement();
              if (type.toLowerCase() == 'page' && this.eFormDesignerService.selectedTab.Pages.length <= 0) {
                this.tabClick(this.eFormDesignerService.selectedTab);
              }
            }
          });
        }
      }
    }, 0);
  }

  copyRowClick() {
    this.eFormDesignerService.locationToAdd = '';
    const copyConfirmDialog = this.dialog.open(EFormRrowColumnLocationComponent, {
      disableClose: true,
    });
    copyConfirmDialog.componentInstance.headerLabel = 'Copy Row';
    copyConfirmDialog.componentInstance.cotrolType = 'row';
    this.subscriptions.push(copyConfirmDialog.afterClosed().subscribe(result => {
      if (result) {
        this.eFormDesignerService.locationToAdd = result;
        this.eFormDesignerService.addRow(false);
      }
      else {
        this.eFormDesignerService.locationToAdd = '';
      }
    }));
  }

  copyColumnClick() {
    this.eFormDesignerService.locationToAdd = '';
    const copyConfirmDialog = this.dialog.open(EFormRrowColumnLocationComponent, {
      disableClose: true,
    });
    copyConfirmDialog.componentInstance.headerLabel = 'Copy Column';
    copyConfirmDialog.componentInstance.cotrolType = 'column';
    this.subscriptions.push(copyConfirmDialog.afterClosed().subscribe(result => {
      if (result) {
        this.eFormDesignerService.locationToAdd = result;
        this.eFormDesignerService.addColumn(this.config);
      }
      else {
        this.eFormDesignerService.locationToAdd = '';
      }
    }));
  }



}
